import React from 'react'
import { AppColors } from '../css/AppColors';

const Notfound = () => {
    return (
        <div style={{ display: 'flex', flexDirection: 'row', textAlign: 'center', alignItems: 'center', justifyContent: 'center', backgroundColor: '#141e2f', height: "100vh" }} >

            <div style={{ color: 'rgba(255,255,255,0.5)', fontSize: 18, }}>404</div>
            <div style={{ color: 'rgba(255,255,255,0.4)', fontSize: 35, marginRight: 12, marginLeft: 12, textAlign: 'center' }}>|</div>
            <div style={{ color: 'rgba(255,255,255,0.5)', fontSize: 18, }}>NOT FOUND</div>

        </div>
    )
}

export default Notfound
